import React from 'react'

export default function Policy() {
    return (
        <div>Policy nè
            đồng ý iii
        </div>
    )
}
